import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { UiTimerWrapperComponent } from '@go-modules/directives/ui-timer/ui-timer-wrapper/ui-timer-wrapper.component';

export const NgxUiTimerModule = angular.module('NgxUiTimerModule', [])
	.directive('uiTimer', downgradeComponent({ component: UiTimerWrapperComponent }))
	.name;
